import { useState, useEffect, useCallback } from 'react';

/**
 * Hook para consultar las licencias y estado de pólizas del cliente del ticket
 */
export const useClientLicenses = ({ idClienteAkasia, token }) => {
  const [licenses, setLicenses] = useState([]);
  const [isLoadingLicenses, setIsLoadingLicenses] = useState(false);

  const fetchLicenses = useCallback(async () => {
    if (!idClienteAkasia || !token) {
      setLicenses([]);
      return [];
    }

    setIsLoadingLicenses(true);
    try {
      const response = await fetch(
        `/api/SupportEngine/GetClientLicenses?idClienteAkasia=${encodeURIComponent(idClienteAkasia)}`,
        {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + token
          }
        }
      );

      if (response.ok) {
        const result = await response.json();
        const list = result.data || result;
        const normalized = Array.isArray(list) ? list : [];
        setLicenses(normalized);
        return normalized;
      }
      setLicenses([]);
    } catch (err) {
      console.error('Error al cargar licencias del cliente para alerta:', err);
      setLicenses([]);
    } finally {
      setIsLoadingLicenses(false);
    }
    return [];
  }, [idClienteAkasia, token]);

  useEffect(() => {
    fetchLicenses();
  }, [idClienteAkasia, fetchLicenses]);

  return {
    licenses,
    isLoadingLicenses,
    fetchLicenses
  };
};
